import React from 'react';
import LinkDownload from '../link/link-download.jsx';
import env from '../../environment.js';

const ModalDescargaRecibo = ({ reciboPdfUrl, onClick }) => {
  return (
        <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1060,
            }}>
            <div
              style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '10px',
                minWidth: '400px',
                textAlign: 'center',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}>
              <div style={{ marginBottom: '20px' }}>
                <h4 style={{ margin: '10px 0', color: '#333' }}>Entrega registrada con éxito</h4>
                <i className="fa fa-check-circle" style={{ fontSize: '40px', color: env.colors.primary_500 }}></i>
              </div>

              <div
                style={{
                  backgroundColor: env.colors.secondary_200,
                  marginBottom: '10px',
                  border: 0,
                }}
                className="btn btn-outline-secondary btn-sirio">
                <LinkDownload
                  url={reciboPdfUrl}
                  label="Descargar recibo y continuar"
                  icon={env.images.icon.pdf}
                  finalFunction={() => {
                    window.location.href = `/admin/acopio/acopio_por_productor/list`;
                  }}
                  color={env.colors.black}
                />
              </div>

              <button
                type="button"
                onClick={onClick}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f8f9fa',
                  color: '#666',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  fontSize: '12px',
                }}>
                Continuar sin descargar
              </button>
            </div>
          </div>
  );
};

export default ModalDescargaRecibo;
